import React, { useEffect, useState } from 'react';
import styles from './roadmap.module.css';

const roadmap = [
  { step: 1,  title: "Fundamentos de Blockchain",           description: "Comprende los principios básicos de blockchain: descentralización, consenso y seguridad." },
  { step: 2,  title: "Economía de los Tokens",               description: "Aprende cómo funcionan los tokens y su impacto en la economía digital." },
  { step: 3,  title: "Tokenización de Activos",              description: "Descubre cómo los activos físicos y digitales pueden representarse en blockchain." },
  { step: 4,  title: "Seguridad en Blockchain",              description: "Explora los mecanismos de seguridad, criptografía y protección contra ataques." },
  { step: 5,  title: "Contratos Inteligentes y Legalidad",   description: "Entiende cómo los contratos inteligentes pueden automatizar procesos legales y comerciales." },
  { step: 6,  title: "Desarrollo de Proyectos",              description: "Aprende a construir un proyecto blockchain desde cero con herramientas modernas." },
  { step: 7,  title: "Cumplimiento Regulatorio",             description: "Conoce las regulaciones y normativas legales en distintas jurisdicciones." },
  { step: 8,  title: "Marketing y Comunidad",                description: "Descubre cómo construir y hacer crecer una comunidad en torno a tu proyecto." },
  { step: 9,  title: "Trading y Exchanges",                  description: "Estrategias de trading y funcionamiento de los exchanges." },
  { step: 10, title: "NFTs y Mercado Digital",               description: "Explora la creación y comercialización de NFTs." },
  { step: 11, title: "Transacciones y Wallets",              description: "Cómo funcionan las billeteras digitales y las transacciones." },
  { step: 12, title: "Aplicaciones Prácticas",               description: "Casos reales de uso en distintas industrias." },
  { step: 13, title: "Riesgos y Beneficios",                 description: "Pros y contras de la tecnología blockchain." },
  { step: 14, title: "Nuevas Tecnologías",                   description: "Interoperabilidad, escalabilidad y tendencias." },
  { step: 15, title: "Cierre y Proyecto Final",              description: "Proyecto final aplicando lo aprendido." },
];

const Roadmap = () => {
  const [items, setItems] = useState([]);

  useEffect(() => { setItems(roadmap); }, []);

  return (
    <div className={styles.roadmap}>
      <header className={styles.header}>
        <h1>Roadmap de Blockchain</h1>
        <p>Explora este roadmap integral para convertirte en un experto, desde lo básico hasta aplicaciones avanzadas.</p>
      </header>

      {items.map((item) => (
        <div key={item.step} className={styles.roadmapStep}>
          <div className={styles.roadmapIcon} aria-hidden="true">
            <span className={styles.iconGlyph}>{item.step}</span>
          </div>
          <div className={styles.roadmapContent}>
            <h2>{item.title}</h2>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Roadmap;
